// features/dependencias/api/dependencias.api.js
import { api } from '../../../api/client';

export const dependenciesApi = {
  /**
   * Obtiene todas las dependencias
   */
  search: (searchData={}) => api.post('/dependencies/search', searchData),

  /**
   * Crea una nueva dependencia
   * @param {object} data
   */
  create: (data) => api.post('/dependencies', data),

  /**
   * Actualiza una dependencia
   * @param {string|number} id
   * @param {object} data
   */
  update: (id, data) => api.put(`/dependencies/${id}`, data),

  /**
   * Elimina una dependencia
   * @param {string|number} id
   */
  remove: (id) => api.delete(`/dependencies/${id}`),

  /**
   * Obtiene info antes de borrar/desactivar dependencia
   * @param {string|number} id
   */
  getDeleteInfo: (id) => api.get(`/dependencies/${id}/delete-info`),

  /** Obtiene nombres de dependencias */
  getNames: () => api.get('/dependencies/names'),
};
